<template>
    <Page header="Мерчанты" type="" :nopadding="false" header_pos="left">
        <template #body>
            <div v-if="!loading && users" class="w-full flex flex-column gap-2">
                <div class="flex gap-2">
                    <AddUser v-if="isUserInGroup('super_admin', accessCodes)" @created="onUserUpdated"/>
                    <Button label="Обновить" icon="pi pi-refresh" @click="reset" severity="secondary" size="small" class="flex"/>
                </div>
                <AdminUserList 
                    :users="users" 
                    :accounts="accounts"
                    :totalUsers="totalUsers" 
                    :loading="loading" 
                    @filter="setFilter"
                    @lazyParams="setParams"
                    @userUpdated="onUserUpdated" />
            </div>
            <Skeleton v-else width="100%" height="30px" />
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import AdminUserList from '@/components/admin/user/list.vue'
import AddUser from '@/components/admin/user/add.vue'
import Page from '@/components/public/page.vue'

export default {
    data() {
        return {
            loading: false,
            users: [],
            accounts: []
        }
    },
    components: {
        AdminUserList,
        AddUser,
        Page
    },
    computed: {
        accessCodes: function () { return this.$store.getters.StateUserAccessCodes },
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        isUserInGroup(user, group) {
            return this.helper.isUserInGroup(user, group)
        },
        setFilter(filters) {
            this.lazyParams.filters = filters
            // this.GetUsers();
        },
        setParams(params) {
            this.lazyParams = params
            // this.GetUsers()
        },
        onUserUpdated() {
            this.GetUsers()
            this.GetAccounts()
        },
        reset() {
            this.lazyParams = {
                first: 0,
                rows: 10,
                sortField: null,
                sortOrder: null,
                filters: {},
            };
            this.GetUsers()
        },
        async GetUsers() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' })
            const account_data = await this.connect.GetAdminUsers().then(res=>res)
            if(account_data.result && account_data.data) {
                this.users = account_data.data
                this.totalUsers = account_data.total
            } else {
                this.users = []
                this.totalUsers = 0
                this.showMess('error', 'Ошибка', 'Ошибка при загрузке пользователей')
            }
            this.loading = false
        },
        async GetAccounts() {
            this.loading = true
            const accounts = await this.connect.GetAdminAccountList(500, 0).then(res=>res)
            if(accounts.result && accounts.data && accounts.data.list) {
                this.accounts = accounts.data.list
            } else {
                this.accounts = []
                this.showMess('error', 'Ошибка', 'Ошибка при загрузке аккаунтов')
            }
            this.loading = false
        },
    },
    async mounted() {
        this.lazyParams = {
            first: 0,
            rows: 10,
            sortField: null,
            sortOrder: null,
            filters: {},
        };
        this.GetUsers()
        this.GetAccounts()
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>